import React from 'react';
import { getBaseURL } from '../../utility/env';

export const IconGoldenPin = ({ size = 16, color = '#8A6A00', ...props }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8 13.2C8 13.2 3.35 8.95 3.35 6.1 3.35 3.5 5.45 1.65 8 1.65s4.65 1.85 4.65 4.45C12.65 8.95 8 13.2 8 13.2Z"
      stroke={color}
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
    <circle cx="8" cy="6" r="1.8" stroke={color} strokeWidth="1.4" />
    <path
      d="M5.15 11.75C3.5 12.1 2.45 12.7 2.45 13.4c0 1.12 2.48 2.03 5.55 2.03s5.55-.91 5.55-2.03c0-.7-1.05-1.3-2.7-1.65"
      stroke={color}
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </svg>
);

export const IconGoldenPinCheck = ({ size = 10, color = '#6B5200', ...props }) => (
  <svg width={size} height={size} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1.7 5.1 3.8 7.3 8.4 2.4" stroke={color} strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconGoldenPinStandsOut = ({ size = 18, color = '#28B16D', ...props }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <ellipse cx="9" cy="15.5" rx="4.3" ry="1.45" stroke={color} strokeWidth="1" strokeOpacity="0.45" />
    <path
      d="M9 15.1C9 15.1 3.9 10.1 3.9 6.5 3.9 3.65 6.2 1.8 9 1.8s5.1 1.85 5.1 4.7C14.1 10.1 9 15.1 9 15.1Z"
      stroke={color}
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
    <path d="M9 11.2C9 11.2 7 8.5 7 6.6 7 5.35 7.88 4.55 9 4.55s2 .8 2 2.05C11 8.5 9 11.2 9 11.2Z" fill={color} />
  </svg>
);

export const IconGoldenPinSeenFirst = ({ size = 18, color = '#28B16D', ...props }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9 4.1c3.5 0 6.1 3.1 6.8 4.9-.7 1.8-3.3 4.9-6.8 4.9S2.9 10.8 2.2 9C2.9 7.2 5.5 4.1 9 4.1Z"
      stroke={color}
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
    <circle cx="9" cy="9" r="2.15" fill={color} />
    <circle cx="8.1" cy="8.1" r="0.62" fill="#FFFFFF" />
  </svg>
);

export const IconGoldenPinDuration = ({ size = 18, color = '#28B16D', ...props }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="2.6" y="4.1" width="12.8" height="11.3" rx="2.2" stroke={color} strokeWidth="1.3" />
    <path d="M2.6 7.7h12.8" stroke={color} strokeWidth="1.3" />
    <path d="M6.2 2.5v2.7M11.8 2.5v2.7" stroke={color} strokeWidth="1.3" strokeLinecap="round" />
    <circle cx="6.3" cy="10.9" r="0.82" fill={color} />
    <circle cx="9" cy="10.9" r="0.82" fill={color} />
    <circle cx="11.7" cy="10.9" r="0.82" fill={color} />
  </svg>
);

const RIYAL_PATH =
  'M12.62 23.20C12.11 22.95 12.07 22.40 12.51 21.68C12.67 21.43 12.86 21.04 12.94 20.83C13.19 20.14 13.37 20.05 14.92 19.84C15.34 19.79 16.04 19.65 16.48 19.52C18.56 18.94 19.99 18.74 20.43 18.96C20.88 19.20 20.90 19.70 20.47 20.34C20.36 20.52 20.20 20.87 20.13 21.12C19.88 21.93 19.79 22.00 18.74 22.15C18.38 22.20 17.77 22.34 17.36 22.46C16.42 22.75 15.68 22.91 14.91 23.00C14.23 23.08 13.09 23.24 12.94 23.28C12.88 23.30 12.74 23.26 12.62 23.20ZM1.25 21.77C0.98 21.53 0.93 21.25 1.01 20.36C1.09 19.27 1.31 18.74 1.83 18.35C2.12 18.13 2.52 18.02 3.26 17.94C4.18 17.84 4.59 17.74 5.62 17.37C6.63 17.02 6.76 16.93 6.88 16.53C6.96 16.23 6.92 15.38 6.80 14.89C6.69 14.45 6.37 14.29 6.02 14.48C5.25 14.92 5.23 14.92 4.36 15.02C3.89 15.08 3.31 15.18 3.06 15.25C2.52 15.42 2.29 15.38 2.08 15.07C1.86 14.75 1.88 14.06 2.12 13.29C2.45 12.29 2.66 12.10 3.70 11.87C4.30 11.74 4.64 11.63 5.30 11.35C5.51 11.26 5.88 11.14 6.11 11.08C6.55 10.98 6.87 10.74 6.88 10.51C6.88 10.46 6.89 8.68 6.90 6.56C6.90 3.17 6.92 2.69 7.01 2.50C7.15 2.19 7.31 2.07 7.79 1.90C8.11 1.78 8.31 1.65 8.57 1.40C8.97 1.03 9.14 0.94 9.50 0.94C9.75 0.94 10.01 1.10 10.13 1.32C10.18 1.41 10.20 2.70 10.20 5.49C10.19 9.83 10.19 9.84 10.51 10.08L10.68 10.21L11.23 10.07C12.23 9.83 12.45 9.56 12.31 8.70C12.26 8.37 12.25 7.57 12.26 6.22L12.28 4.22L12.46 3.80C12.66 3.34 12.79 3.19 13.52 2.54C14.06 2.06 14.43 1.89 15.04 1.83C15.35 1.80 15.47 1.82 15.60 1.90C15.94 2.13 15.95 2.18 15.93 5.50C15.92 8.85 15.91 8.73 16.29 8.98C16.44 9.08 16.50 9.08 17.30 8.97C17.77 8.92 18.53 8.78 18.98 8.68C20.08 8.43 20.29 8.43 20.51 8.68C20.87 9.09 20.81 9.68 20.28 10.83C20.08 11.25 19.86 11.67 19.77 11.76C19.60 11.94 19.22 12.06 18.83 12.06C18.40 12.06 17.04 12.32 16.71 12.47C16.54 12.55 16.32 12.70 16.23 12.82C16.03 13.08 15.87 13.62 15.88 14.02C15.88 14.28 15.90 14.35 16.09 14.54C16.39 14.84 16.77 14.84 17.37 14.53C18.60 13.91 20.13 13.76 20.55 14.21C20.80 14.47 20.79 14.73 20.54 15.21C20.41 15.44 20.26 15.85 20.19 16.13C20.00 16.96 19.87 17.07 18.87 17.22C18.51 17.27 17.94 17.40 17.59 17.50C16.79 17.74 15.80 17.98 15.41 18.03C15.23 18.05 14.67 18.14 14.15 18.23C13.09 18.42 12.85 18.40 12.54 18.12C12.22 17.84 12.19 17.63 12.23 15.78C12.26 14.30 12.26 14.13 12.16 13.92C11.91 13.40 11.22 13.37 10.60 13.83C10.23 14.12 10.19 14.30 10.16 15.64C10.14 17.08 10.03 17.58 9.57 18.50C9.40 18.82 9.22 19.24 9.16 19.41C9.04 19.78 8.83 20.01 8.47 20.16C8.33 20.21 7.99 20.37 7.72 20.51C7.16 20.78 6.53 20.92 5.03 21.09C3.96 21.21 2.85 21.48 2.34 21.74C1.84 22.00 1.51 22.00 1.25 21.77Z';

// Pin positions copied from the design prototypes (web: 540x156 canvas, mweb: 440x186 canvas).
const VARIANTS = {
  web: {
    viewBox: '0 0 540 156',
    height: 150,
    image: 'golden-pin-map.webp',
    imageBox: { x: -1, y: -1, width: 542, height: 158 },
    shimmerId: 'gpShimW',
    pins: [
      { x: 68, y: 16, label: '1.4M' },
      { x: 294, y: 20, label: '940K' },
      { x: 56, y: 104, label: '237K' },
      { x: 244, y: 116, label: '758K' },
      { x: 428, y: 78, label: '2.1M' },
      { x: 172, y: 56, label: '680K', gold: true },
    ],
  },
  mweb: {
    viewBox: '0 0 440 186',
    height: 166,
    image: 'golden-pin-map-mweb.webp',
    imageBox: { x: -1, y: -1, width: 442, height: 188 },
    shimmerId: 'gpShimM',
    pins: [
      { x: 60, y: 20, label: '1.4M' },
      { x: 320, y: 28, label: '940K' },
      { x: 102, y: 142, label: '758K' },
      { x: 202, y: 80, label: '680K', gold: true },
    ],
  },
};

const PinShape = ({ x, y, label, gold }) => {
  const ink = gold ? '#000000' : '#222222';
  return (
    <>
      <rect x={x} y={y + 1.2} width="48" height="20" rx="4" fill="rgba(23,26,31,0.22)" />
      <path d={`M${x + 21.4} ${y + 20.2}h5.2L${x + 24} ${y + 24.2}z`} fill="rgba(23,26,31,0.22)" />
      <rect x={x} y={y} width="48" height="20" rx="4" fill={gold ? '#FFD60A' : '#FFFFFF'} />
      {gold && (
        <>
          <path d={`M${x + 4} ${y + 0.5}h40`} stroke="rgba(255,255,255,0.72)" strokeWidth="1" />
          <path d={`M${x + 4} ${y + 19.5}h40`} stroke="rgba(120,86,10,0.55)" strokeWidth="1" />
        </>
      )}
      <path d={`M${x + 21.4} ${y + 19.4}h5.2L${x + 24} ${y + 23}z`} fill={gold ? '#E8C230' : '#FFFFFF'} />
      <g transform={`translate(${x + 5} ${y + 5.2}) scale(0.4)`}>
        <path d={RIYAL_PATH} fill={ink} />
      </g>
      <text x={x + 17.2} y={y + 14.3} fontFamily="Lato, sans-serif" fontSize="11" fontWeight="400" fill={ink}>
        {label}
      </text>
    </>
  );
};

/**
 * Explainer illustration for the Golden Pin modals: one gold pin among ordinary price pins on the
 * Bayut map. The gold pin floats slowly; `shimmer` adds the highlight sweep used by the intro pop-up.
 * Pin labels are decorative and intentionally not translated.
 */
export const IconGoldenPinMap = ({ variant = 'web', shimmer = false, fit = false, title }) => {
  const cfg = VARIANTS[variant] || VARIANTS.web;
  const goldPin = cfg.pins.find((p) => p.gold);
  const ordinaryPins = cfg.pins.filter((p) => !p.gold);

  return (
    <svg
      width="100%"
      height={fit ? undefined : cfg.height}
      viewBox={cfg.viewBox}
      fill="none"
      role="img"
      preserveAspectRatio="xMidYMid slice"
      aria-label={title}
      // The illustration is a fixed map picture: keep it left-to-right so pin labels don't flip in Arabic.
      style={{
        display: 'block',
        direction: 'ltr',
        // `fit` shows the whole illustration (no top/bottom crop) at the container's width.
        ...(fit && { height: 'auto', aspectRatio: cfg.viewBox.split(' ').slice(2).join(' / ') }),
      }}
    >
      <image
        href={`${getBaseURL()}/profolio-assets/bayut/images/${cfg.image}`}
        x={cfg.imageBox.x}
        y={cfg.imageBox.y}
        width={cfg.imageBox.width}
        height={cfg.imageBox.height}
      />
      {shimmer && (
        <defs>
          <linearGradient
            id={cfg.shimmerId}
            gradientUnits="userSpaceOnUse"
            x1={goldPin.x - 34}
            y1="0"
            x2={goldPin.x - 16}
            y2="0"
          >
            <stop offset="0" stopColor="#FFFFFF" stopOpacity="0" />
            <stop offset="0.5" stopColor="#FFFFFF" stopOpacity="0.92" />
            <stop offset="1" stopColor="#FFFFFF" stopOpacity="0" />
            <animate
              attributeName="x1"
              values={`${goldPin.x - 34};${goldPin.x + 82}`}
              dur="2.6s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="x2"
              values={`${goldPin.x - 16};${goldPin.x + 100}`}
              dur="2.6s"
              repeatCount="indefinite"
            />
          </linearGradient>
        </defs>
      )}
      {ordinaryPins.map((p) => (
        <g key={`${p.x}-${p.y}`}>
          <PinShape {...p} />
        </g>
      ))}
      <g>
        <animateTransform
          attributeName="transform"
          type="translate"
          values="0 0; 0 -2.6; 0 0"
          dur="2.8s"
          repeatCount="indefinite"
          calcMode="spline"
          keyTimes="0; 0.5; 1"
          keySplines="0.45 0 0.55 1; 0.45 0 0.55 1"
        />
        <PinShape {...goldPin} />
        {shimmer && <rect x={goldPin.x} y={goldPin.y} width="48" height="20" rx="4" fill={`url(#${cfg.shimmerId})`} />}
      </g>
    </svg>
  );
};
